var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('v-alert',{attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v(" "+_vm._s(_vm.$t('workspace.messages.noWorkspace'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }